import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {Toggle} from 'components/forms';
import styles from './styles.css';

@autobind
export default class CheckboxGroup extends Component {
    static propTypes = {
        value: PropTypes.array.isRequired,
        options: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired,
        })).isRequired,
        disabled: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
    };

    handleChange(option) {
        return checked => {
            let newValues = this.props.value;
            if (checked) {
                if (!this.props.value.includes(option.value)) {
                    newValues = [...this.props.value, option.value];
                }
            } else {
                newValues = this.props.value.filter(value => value !== option.value);
            }
            this.props.onChange(newValues);
        };
    }

    render() {
        return (
            <div className={classNames(styles.root, {[styles.disabled]: this.props.disabled})}>
                {this.props.options.map(option => (
                    <Toggle
                        key={option.value}
                        type='checkbox'
                        value={this.props.value.includes(option.value)}
                        label={option.label}
                        disabled={this.props.disabled}
                        onChange={this.handleChange(option)}
                        onBlur={this.props.onBlur}
                    />
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/forms/checkbox-group/index.js